import React, { useEffect, useState } from 'react';
import WindowSize from '@/utils/windowSize';
import SvgClose from '@/components/shared/SvgClose';
import { jsonToHtml } from '@contentstack/json-rte-serializer';
import { customHTMLSerializer } from '@/utils/articles/customHTMLSerializer';

export default function VariantSelectorModal({
  isOpen,
  hideModal,
  modalCopy,
  modalHeading
}) {
  const modal_copy = jsonToHtml(modalCopy, customHTMLSerializer);

  useEffect(() => {
    if (isOpen == true) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add('overflow-hidden');
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    }
    return () => {
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    };
  }, [isOpen]);

  const windowSize = WindowSize();
  const [onMobile, setOnMobile] = useState();

  useEffect(() => {
    if (windowSize.width >= 640) {
      setOnMobile(false);
    } else {
      setOnMobile(true);
    }
  }, [windowSize]);

  return (
    <div
      id="modal-default-secondary-selector"
      className={`modal-default ${isOpen == true ? 'flex touch-none' : 'hidden'} fixed inset-0 top-0 ${onMobile ? 'bg-modal-light-grey/80' : 'bg-modal-light-grey/50'} modal-wrapper flex-row flex-wrap items-center justify-center`}
      role="dialog"
      aria-modal="true"
      modal-toggler="true"
      onClick={(e) => hideModal(e)}
    >
      <div
        id="modal-body-secondary-selector"
        className="modal-body body-r border-dawn-grey-30 relative mx-8 my-8 max-h-[510px] w-full max-w-xl overflow-auto border bg-white px-6 py-20 text-left opacity-100 sm:max-h-screen sm:max-w-2xl sm:px-12"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-4 right-4 px-2"
          onClick={(e) => hideModal(e)}
        >
          <SvgClose stroke={'#000000'} type="x" />
        </button>
        <div className="h4 text-parlor-green pb-5 text-center">
          {modalHeading}
        </div>
        <div
          className="rte text-black"
          dangerouslySetInnerHTML={{ __html: modal_copy }}
        />
      </div>
    </div>
  );
}
